/* eslint-disable jsx-a11y/alt-text */
import React, { useState,useEffect, useContext } from 'react'
import './header.css'
import Drawer from '../../components/drawer/Drawer';
import Popup from '../popup/Popup';
import common   from '../config/common.json';
import { Avatar } from '@material-ui/core';
import {useIntl} from 'react-intl';
import getGlobalVarContext from "../context/getGlobalVarContext";


function Header() {
  const { globalVar, setGlobalVar } = useContext(getGlobalVarContext());
  const { isRightSideBarOpen } = globalVar;
  const intl = useIntl()
  
  function getPlan() {
    var requestOptions = {
      method: "GET"
    };
    fetch(`${common.BASEURL}/user/details?email=${localStorage.getItem("email")}`, requestOptions)
    .then(res => res.json())
      .then(
        (result) => {
          if(result.msg.subscription_id === undefined){
            localStorage.setItem("subscription_plan_id", false);
            document.getElementById("plan_type").innerHTML =intl.formatMessage({id: "upgradePlan"});
          }else{
             document.getElementById("plan_type").innerHTML =intl.formatMessage({id: "viewPlan"});
             localStorage.setItem("subscription_plan_id", true);
          }
        }
      ).catch(error => {
        localStorage.setItem("subscription_plan_id", false);
        document.getElementById("plan_type").innerHTML =intl.formatMessage({id: "upgradePlan"})
      });

  }
  const [buttonOpen, setButtonOpen] = useState(false);
  var profile_url=""
  if(localStorage.getItem("profile_user") !== null && localStorage.getItem("profile_user") !== undefined){
    profile_url=localStorage.getItem("profile_user")
  }

 useEffect(() =>{
  getPlan();
 },[])

  return (
    <>
    <div className='headerContainer' id='mainHeader'>
        <div className='headerLeft'>
            <img src={`${common.ClientId}_logo.png`}/> 
            <div style={{width:"140px"}}>{intl.formatMessage({id: "appName"},{ name: common.app_name })}</div>
        </div>
        
        <div className='headerRight'>
        <div className="marginrightplan">
        <h4 id="plan_type" onClick={() => setButtonOpen(true)}>{intl.formatMessage({id: "upgradePlan"})}</h4>
        </div>
            <h4 style={{fontWeight:"400"}} onClick = {() =>{
              console.log("single",isRightSideBarOpen);
              setGlobalVar((oldState) => ({ ...oldState, isRightSideBarOpen: !isRightSideBarOpen}))
              }}> <Avatar src={profile_url}>{intl.formatMessage({id: "headerDrawerAvatar"})}</Avatar>
            </h4>
        </div> 
    </div>
    <Popup trigger={buttonOpen} setTrigger={setButtonOpen}></Popup>
    </>
  )
}

export default Header